// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import {
  printarchiveVoucher,
  mapkey,
} from "../../../redux/actions/frontActions";
import { voucherStatus } from "../../../redux/actions/frontActions";

import logo from "../../../img/ddb-logo.png";

import { appConfig } from "../../../config";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import ReactHtmlParser from "react-html-parser";

const history = createBrowserHistory();
let isLoading = "false";
class PrintarchiveVouchers extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      voucher: "",
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {
    this.setState({
      show: false,
    });
  }

  handlePageChange = (lang = "en") => {
    let voucherIDParams = this.props.match.params.voucherId
      ? this.props.match.params.voucherId
      : "";
    let type = "paid";
    if (voucherIDParams !== "") {
      isLoading = "true";
      this.props.printarchiveVoucher(voucherIDParams, type, "en");
    }
  };

  onVoucherRedeem = (voucherNumber) => {
    this.props.voucherStatus({
      voucherNumber: voucherNumber,
      lang: this.state.default_lang,
      redeemedBy: "Admin",
    });
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    this.handlePageChange(siteData.default_lang);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.voucherDetail !== nextProps.voucherDetail) {
      if (nextProps.voucherDetail) {
        isLoading = "false";
        this.setState({ voucher: nextProps.voucherDetail });
      }
    }

    if (this.props.orderRedeem != nextProps.orderRedeem) {
      if (nextProps.orderRedeem) {
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("success", nextProps.orderRedeem.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  render() {
    const style = {
      width: "100%",
      height: "100%",
    };

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.show && this.state.alertMessage !== "" && (
          <div
            className=""
            style={{
              width: 1087,
              marginLeft: 27,
              marginTop: 13,
              marginBottom: -46,
            }}
          >
            <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
            </Alert>
          </div>
        )}

        <div className="panel voucher-detail margin-top">
          <header className="panel-heading">
            <span>Archive Voucher Detail </span>
            <Button
              style={{ height: 31 }}
              bsSize="small"
              className="pull-right"
              bsStyle="success"
              type="submit"
              onClick={this.printDiv.bind(this)}
            >
              <i className="glyphicon glyphicon-print" /> Print
            </Button>
            {/* 
            <Button
              style={{ height: 31 }}
              onClick={() =>
                this.onVoucherRedeem(this.state.voucher.data.voucherNumber)
              }
            >
              <i className="glyphicon glyphicon-check" /> Mark as Used
            </Button> */}
          </header>
          <div className="panel-body" id="DivIdToPrint">
            {!isEmpty(this.state.voucher) ? (
              <Row>
                <Col md={12} xs={12}>
                  {!isEmpty(this.state.voucher.template)
                    ? ReactHtmlParser(this.state.voucher.template)
                    : ""}
                </Col>
              </Row>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

PrintarchiveVouchers.propTypes = {
  printarchiveVoucher: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  voucherDetail: state.frontReducer.voucherarchiveDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  orderRedeem: state.frontReducer.ordertracking,
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    { printarchiveVoucher, voucherStatus, renderAlert, clearAlert },
    null,
    {
      pure: false,
    }
  )
)(PrintarchiveVouchers);



// WEBPACK FOOTER //
// ./src/app/views/admin/voucher/PrintarchiveVouchers.js